import React from 'react'
import { RootContext } from './rootContext'

function withRootContext (Component) {
  function contextComponent (props) {
    return (
      <RootContext.Consumer>
        {context => <Component {...props} context={context} />}
      </RootContext.Consumer>
    )
  }

  if (Component.getInitialProps) {
    contextComponent.getInitialProps = Component.getInitialProps
  }

  Object.assign(contextComponent, Component)

  return contextComponent
}

export default withRootContext
